module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qpelv4-6aa79f71aad448e0ebc636a60b59f13d.jpg";